const spacers = /** @type {const} */ ([
  0, 480, 320, 240, 192, 160, 124, 96, 84, 72, 64, 54, 48, 40, 32, 28, 24, 20,
  18, 16, 12, 10, 8, 6, 4,
]);

module.exports = spacers;
